import { creditLimitService } from '@afterpaytouch/portal-api/consumer/creditLimit'

export const {
  useGetCreditLimitQuery,
  useLazyGetCreditLimitQuery,
  useGetConsumerLendingCreditLimitQuery,
  useGetConsumerLendingDecreaseCreditLimitOptionsQuery,
  useDecreaseConsumerLendingCreditLimitMutation,
} = creditLimitService
